"use client";

import { resolveText } from "./binding";
import { resolveMacaronIconComponent, type MacaronIconStyle } from "./macaronIconRegistry";
import type { MacaronRenderContext, RecordAny } from "./types";

export function MacaronIcon({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const name = resolveText(config.name, ctx.data) || "";
  const style = (typeof config.style === "string" && (config.style === "line" || config.style === "filled") ? config.style : "line") as MacaronIconStyle;
  const resolvedIcon = resolveMacaronIconComponent(name, style);
  return (
    <span className="flex h-5 w-5 items-center justify-center leading-none">
      {resolvedIcon ? (
        <resolvedIcon.Component data-macaron-icon={resolvedIcon.canonicalName} data-macaron-icon-style={style} className="h-5 w-5" />
      ) : (
        <span className="flex h-5 w-5 items-center justify-center rounded text-[13px] font-bold leading-none" style={{ backgroundColor: "rgba(217, 45, 32, 0.14)", border: "1px solid rgba(217, 45, 32, 0.7)", color: "rgba(217, 45, 32, 0.7)" }}>
          ?
        </span>
      )}
    </span>
  );
}
